import "./components/accordion";
import "./components/slider";
import "./components/testimonials";
import "./components/lottie";
import "./components/location-hero";
// import './components/meganav'
import "./components/marquee";
import "./components/hp-hero";
import "./components/hp-grid";
import "./components/location-banners";
import "./components/sevelamer";
import "./components/discover-codis-slider";
import "./components/insights-slider";
import "./components/policy";
import "./components/resource-gating";
//import "./components/floating-labels";

import { gsap } from "gsap";
import { observeAndAnimate, horizontalLoop } from "./components/utils";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
ScrollSmoother.create({
  smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
  effects: true, // looks for data-speed and data-lag attributes on elements
  smoothTouch: 0, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
});

// Generic Animation functions
function slideIn(element) {
  gsap.to(element, { translateX: 0 });
}
function slideUp(element) {
  gsap.to(element, { translateY: 0 });
}

// Observing and animating specific elements
observeAndAnimate("g.hero-chevron-purple", slideIn);
observeAndAnimate("g.cta-chevrons", slideIn);

// scaling sections
gsap.utils
  .toArray(
    "body.page main > section:not(:first-child), body.single-location main > article  > section:not(:first-child)"
  )
  .forEach((section) => {
    // Set initial scale
    gsap.set(section, { scale: 0.95, transformOrigin: "center center" });

    gsap.to(section, {
      scale: 1,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top 95%", // when section enters viewport
        end: "top 70%", // until section leaves viewport
        scrub: true,
        //smoothChild: true,   // <-- helps ScrollSmoother interaction
      },
    });
  });
